import React, { useState, useEffect } from 'react';
import AppRoute from './components/Router/index';
import Contact from './components/ContactUs/ContactUs';
import { Provider, ErrorBoundary } from '@rollbar/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import ScrollButton from './components/UI/ScrollToTop/ScrollToTop';
import {
  checkExclusiveUser,
  checkSub,
  subscription_list,
  getProduct_plan,
  createPayg,
} from './Action/action';
import Loader from './components/UI/Loader/Loader';
import rollbarConfig from './services/rollbarConfig';
import Error from './components/UI/Error/Error';

var product;
var plan_details;
var ActiveProduct;
var previousPayment;

var subscription_details = [];

function App() {
  const contact = useSelector((state) => state.menuReducer.enterprise);
  const plan = useSelector((state) => state.menuReducer.contactPlan);
  const profile = useSelector((state) => state.menuReducer.profile);
  const loading = useSelector((state) => state.AuthReducer.loading);
  const subscribed = useSelector((state) => state.menuReducer.subscription);
  const teams = useSelector((state) => state.menuReducer.teams);
  const advancePlans = useSelector((state) => state.menuReducer.advancePlans);
  const wallet = useSelector((state) => state.menuReducer.wallet);

  const dispatch = useDispatch();

  useEffect(() => {
    const checkValidSubscription = () => {
      let subscriptionDetail = subscribed;
      let subs = subscriptionDetail.subscriptionDTOs;
      let unSubscribedProduct =
        subs && subs.filter((item) => item.subscriptionStatus !== 'ACTIVE');
      if (subs) {
        subs.map((product) => {
          subscription_details.push({
            product: product.productType,
            plan: product.planType,
            status: product.subscriptionStatus,
          });
        });
      }

      const insightsEnterprise = subs?.find(
        (item) => item.productType === 'INSIGHTS' && item.planType === 'POC',
      );

      if (subs && subs.length > 2) {
        if (insightsEnterprise !== undefined) {
          ActiveProduct = subs?.filter(
            (item) =>
              item.productType === 'INSIGHTS' && item.subscriptionStatus === 'ACTIVE',
          );
        } else {
          ActiveProduct = subs?.filter(
            (item) => item.productType === 'BUY' && item.subscriptionStatus === 'ACTIVE',
          );
        }
      } else {
        if (insightsEnterprise !== undefined) {
          ActiveProduct = subs?.filter(
            (item) =>
              item.productType === 'INSIGHTS' && item.subscriptionStatus !== 'ACTIVE',
          );
        } else {
          ActiveProduct = subs?.filter(
            (item) => item.productType === 'BUY' && item.subscriptionStatus !== 'ACTIVE',
          );
        }
      }

      let check =
        unSubscribedProduct &&
        unSubscribedProduct[0]?.endDate &&
        new Date(unSubscribedProduct[0].endDate).getTime() > new Date().getTime();
      if (subscriptionDetail.subscribedUser) {
        product = subs[0].productType;
        plan_details = subs[0].planType;
        let buyPayment =
          wallet?.balance && wallet?.balance.find((item) => item.product === 'BUY');
        previousPayment =
          buyPayment && buyPayment?.walletTrxnHistoryDTO.length > 0 ? true : false;
        if (advancePlans && advancePlans.includes(plan_details)) {
          dispatch(
            checkExclusiveUser(
              true,
              ActiveProduct && ActiveProduct[0] && ActiveProduct[0].subscriptionStatus,
              ActiveProduct && ActiveProduct[0] && ActiveProduct[0].planType,
              ActiveProduct && ActiveProduct[0] && ActiveProduct[0].productType,
              previousPayment && previousPayment,
            ),
          );
        }
        return true;
      } else if (!subscriptionDetail.hasEverPurchased) return false;

      if (check) {
        product = unSubscribedProduct && unSubscribedProduct[0].productType;
        plan_details = unSubscribedProduct && unSubscribedProduct[0].planType;
      }

      /**** TO BE UNCOMMENTED IF END DATE IS KEPT IN CONSIDERATION ****/
      return check;
    };
    dispatch(getProduct_plan(product, plan_details));
    dispatch(checkSub(checkValidSubscription()));
    dispatch(subscription_list(subscription_details));
  }, [plan, profile, subscribed, teams, contact, wallet]);

  return (
    <>
      <Provider config={rollbarConfig}>
        <ErrorBoundary fallbackUI={Error}>
          {loading && <Loader />}
          <AppRoute />
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Contact type={contact} plan={plan} profile={profile} />
          <ScrollButton />
        </ErrorBoundary>
      </Provider>
    </>
  );
}

export default App;
